const VERSION = '3.1.5';

export { VERSION };
